import {RouteConfig} from "vue-router";

/** @type {RouteConfig[]} */
const routes = [
	{
		path: "/",
		redirect: "/home",
	},
	{
		path: "/home",
		component: () => import("../pages/home/Home.vue"),
		meta: {login: true},
	},
	{
		path: "/main",
		component: () => import("../pages/main/Main.vue"),
		children: [
			{
				path: "tpys",
				component: () => import("../pages/gongneng/tpYs.vue"),
			},
			{
				path: "spys",
				component: () => import("../pages/gongneng/spYs.vue"),
			},
			{
				path: "pdfys",
				component: () => import("../pages/gongneng/pdfYs.vue"),
			},
			{
				path: "wordys",
				component: () => import("../pages/gongneng/wordYs.vue"),
			},
			{
				path: "pptys",
				component: () => import("../pages/gongneng/pptYs.vue"),
			},
		],
	},
];

// Always leave this as last one
if (process.env.MODE !== "ssr") {
	routes.push({
		path: "*",
		component: () => import("../pages/Error404.vue"),
		meta: {login: false},
	});
}

export default routes;
